// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import getWorkshopDataEpic from './getWorkshopDataEpic';
import getWorkshopContentsDataEpic from './getWorkshopContentsDataEpic';
import getWorkshopNotesDataEpic from './getWorkshopNotesDataEpic';
import createWorkshopNoteEpic from './createWorkshopNoteEpic';
import deleteWorkshopNoteEpic from './deleteWorkshopNoteEpic';
import updateWorkshopNoteEpic from './updateWorkshopNoteEpic';
import updateWorkshopProgressEpic from './updateWorkshopProgressEpic';

export default [
  getWorkshopDataEpic,
  getWorkshopContentsDataEpic,
  getWorkshopNotesDataEpic,
  createWorkshopNoteEpic,
  deleteWorkshopNoteEpic,
  updateWorkshopNoteEpic,
  updateWorkshopProgressEpic
]
